module.exports = new __parcel__URL__("CineBriqueVQ.9e063966.webp").toString();